import script from "./FloatActionButtonmobile.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatActionButtonmobile.vue?vue&type=script&setup=true&lang=js"

import "./FloatActionButtonmobile.vue?vue&type=style&index=0&id=27a03fc2&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a03fc2"]])

export default __exports__